export default __webpack_public_path__ + "products-filter.v17/ico_arrow_down.89d8f481.svg";